module.exports = __webpack_public_path__ + "img/dimmer.50e9aecd.png";